@if (stock.error()) {
  <ideal-error [error]="stock.error()"></ideal-error>
} @else if (stock.loading()) {
  <div *loadingSkeleton2></div>
} @else if (stock()) {
  <mat-list role="list">
    @for (branch of branchesSorted(); track branch.branchId) {
      @let isHomeBranch = branch.isHomeBranch;
      <mat-list-item role="listitem" [class.is-home]="isHomeBranch">
        <div matListItemLine>
          @if (isHomeBranch) {
            <div icon>
              <mat-icon>storefront</mat-icon>
            </div>
          }
          <div left>
            <div name>{{ branch.branchName }}</div>
          </div>
          <div right>{{ branch.quantity | number }}</div>
        </div>
      </mat-list-item>
    }
  </mat-list>
  <div total>
    <div left>Total</div>
    <div right>{{ total() | number }}</div>
  </div>
}

<ng-container [renderTarget]="Slots.Display" />

<ideal-component-outlets [components]="providers()" [inputs]="componentInputs()" />
